import $ from 'jquery'
import * as bootstrap from 'bootstrap'
import hljs from 'highlight.js'
import { Application } from '@hotwired/stimulus'
import { registerControllers } from 'stimulus-vite-helpers'

// Initialize Stimulus application
const application = Application.start()

// Register all controllers from the controllers directory
const controllers = import.meta.glob('../controllers/*_controller.js', { eager: true })
registerControllers(application, controllers)

$(function() {
  console.log('application.ts', bootstrap)
  hljs.highlightAll()
})
